<template>
  <div ref="background" class="stats" @click="closeModal">

    <div class="stats__content">
      <div class="stats__header">
        <h2 v-if="typeDistrict">{{ data.Title.GemeenteNaam._text }}, {{ data.ProvincieNaam._text }} ({{ $numberWithDots(data.AantalInwoners._text)
        }} inwoners)</h2>
        <h2 v-else>{{ data.Naam._text }},  ({{ $numberWithDots(data.AantalInwoners._text) }} inwoners)</h2>
        <h3 v-if="data.Title.Postfix">{{ data.Title.Postfix._text }}</h3>
        <button class="stats__close" @click="$emit('close')">&times;</button>
      </div>
      <div class="stats__table-container">
        <div class="stats__meta">
          <h3>
            <div v-if="typeDistrict">Kieskring: {{ data.Kieskring._text }}</div>
            {{ data.Status._text }}
          </h3>
          <ul>
            <li><strong>ANP nr:</strong> {{ data._attributes.anpNr }}</li>
            <li v-if="typeDistrict">
              <strong>CBS:</strong> {{ data.CBS._text }}
            </li>
          </ul>
        </div>
        <template>
          <table v-if="partyStats('totals').Zetels" class="stats__table">
            <thead>
              <td class="force-padding">Zetels</td>
              <td v-for="year in years" :key="year" class="has-table">
                <table>
                  <tr>
                    <td colspan="1" class="col-year" style="text-align: center">
                      {{ year }}
                    </td>
                  </tr>
                  <tr>
                    <td># zetels</td>
                  </tr>
                </table>
              </td>
            </thead>
            <tr>
              <td>Zetels</td>
              <td
                v-for="(year, key) in partyStats('totals').Zetels.years"
                :key="key"
                class="has-table"
              >
                <table>
                  <tr>
                    <td>{{ year.Zetels._text }}</td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>

          <table class="stats__table">
            <thead>
              <td class="force-padding">Totaal</td>
              <td v-for="year in years" :key="year" class="has-table">
                <table>
                  <tr>
                    <td colspan="2" class="col-year" style="text-align: center">
                      {{ year }}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      % perc
                    </td>
                    <td>
                      # stem
                    </td>
                  </tr>
                </table>
              </td>
            </thead>
            <tr
              v-for="(party, key) in partyStats('totals')"
              v-if="party.name !== 'Zetels'"
              :key="key"
            >
              <td>{{ party.name }}</td>
              <td
                v-for="(year, key2) in party.years"
                :key="key2"
                class="has-table"
              >
                <table>
                  <tr>
                    <td>{{ year.Perc ? year.Perc._text : "-" }}</td>
                    <td v-if="year.Stemmen">
                      {{ $numberWithDots(year.Stemmen._text) }}
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>

          <table class="stats__table">
            <thead>
              <td class="force-padding">Partij</td>
              <td v-for="year in years" :key="year" class="has-table">
                <table>
                  <tr>
                    <td
                      :colspan="
                        !typeDistrict && partyStats('totals').Zetels ? 3 : 2
                      "
                      class="col-year"
                      style="text-align: center"
                    >
                      {{ year }}
                    </td>
                  </tr>
                  <tr>
                    <td @click="tableFilter({ year: year, key: 'Perc' })">
                      <div class="table-head-sortable">
                        % perc
                        <span :class="[sortActive(year, 'Perc')]"/>
                      </div>
                    </td>
                    <td @click="tableFilter({ year: year, key: 'Stemmen' })">
                      <div class="table-head-sortable">
                        # stem
                        <span :class="[sortActive(year, 'Stemmen')]"/>
                      </div>
                    </td>
                    <td
                      v-if="!typeDistrict && partyStats('totals').Zetels"
                      @click="tableFilter({ year: year, key: 'Zetels' })"
                    >
                      <div class="table-head-sortable">
                        zetels
                        <span :class="[sortActive(year, 'Zetels')]"/>
                      </div>
                    </td>
                  </tr>
                </table>
              </td>
            </thead>
            <tr
              v-for="(party, key) in partyStats('parties')"
              :key="key"
              :style="highlightParty(party.name)"
            >
              <td>{{ party.name }}</td>
              <td
                v-for="(year, key2) in party.years"
                :key="key2"
                class="has-table"
              >
                <table>
                  <tr>
                    <td>{{ year.Perc._text }}</td>
                    <td>{{ $numberWithDots(year.Stemmen._text) }}</td>
                    <td v-if="!typeDistrict && year.Zetels">
                      {{ year.Zetels._text }}
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tablestats",
  props: {
    data: { type: Object, required: true },
    settings: { type: Object, default: () => ({}) },
    newWindow: { type: Boolean, default: false }
  },
  data() {
    return {
      sortHighest: true,
      filterSettings: null
    };
  },
  computed: {
    sortActive: ctx => (year, key) => {
      if (
        ctx.filterSettings &&
        ctx.filterSettings.year === year &&
        ctx.filterSettings.key === key
      ) {
        if (ctx.filterSettings.sortUp) {
          return "up";
        }
        return "down";
      }
      return "";
    },
    parties() {
      const partyData = this.data.Groep.filter(
        g => g._attributes.type === "Partij"
      );
      if (this.filterSettings) {
        return partyData.sort((a, b) => {
          // function to extract values per iteration element
          const value = key =>
            key.Verkiezing.find(
              v => v._attributes.code === this.filterSettings.year
            );
          // if its empty, place it at the bottom
          if (!value(b)[this.filterSettings.key]) {
            return 0;
          }
          const first = Number(
            value(this.filterSettings.sortUp ? b : a)[
              this.filterSettings.key
            ]._text.replace(",", ".")
          );
          const second = Number(
            value(this.filterSettings.sortUp ? a : b)[
              this.filterSettings.key
            ]._text.replace(",", ".")
          );
          if (first < second) return -1;
          if (first > second) return 1;

          return 0;
        });
      }
      return partyData;
    },
    totals() {
      return this.data.Groep.filter(g => g._attributes.type === "Totaal");
    },
    years() {
      return this.parties[0].Verkiezing.map(v => v._attributes.code);
    },
    typeDistrict() {
      return this.data._attributes.type === "Gemeente";
    },
    typeProvince() {
      return this.data._attributes.type === "Provincie";
    },
    overviewYears() {
      const codes = this.data.Groep.map(g =>
        g.Verkiezing.map(c => c._attributes.code)
      );
      // Set() removes any duplicates that are present in an array
      return Array.from(new Set([].concat(...codes)));
    }
  },
  watch: {
    "data._attributes.anpNr": {
      // turn off filters when new entry has been selected
      handler() {
        this.filterSettings = null;
      }
    }
  },
  methods: {
    closeModal(e) {
      if (e.target === this.$refs.background) {
        this.$emit("close");
      }
    },
    tableFilter(settings) {
      let sortUp = true;
      if (
        this.filterSettings &&
        this.filterSettings.year === settings.year &&
        this.filterSettings.key === settings.key
      ) {
        sortUp = !this.filterSettings.sortUp;
      }
      this.filterSettings = { ...settings, sortUp };
    },
    highlightParty(name) {
      if (this.settings.party) {
        if (this.settings.party === name) {
          return { backgroundColor: "#e6f5cf" };
        }
      }
      return { backgroundColor: null };
    },
    partyStats(key) {
      const newData = {};
      for (const party of this[key]) {
        newData[party.KorteNaam._text] = { name: party.Naam._text, years: {} };
        party.Verkiezing.forEach(y => {
          newData[party.KorteNaam._text].years[y._attributes.code] = y;
        });
      }
      return newData;
    }
  }
};
</script>

<style lang="scss">
@import "../util.scss";
.stats {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  display: block;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;

  &__close {
    position: absolute;
    right: 12px;
    top: 8px;
    border: 0;
    font-size: 30px;
    line-height: 1;
    padding: 0 8px;
    cursor: pointer;
    background: transparent;
  }
  &__header {
    border-bottom: 1px solid $border-medium;
    position: relative;
    padding-right: 50px;

    h2 {
      font-weight: 500;
      font-size: 24px;
      padding: 12px;
      margin: 0;
    }
    h3 {
      line-height: 1.5em;
      font-size: 16px;
      padding: 0 12px;
      margin-top: -12px;
    }
  }

  &__new-window {
    position: absolute;
    right: 12px;
    top: 18px;
    width: 20px;
    height: 20px;
    background: {
      image: url("../assets/expand-button.svg");
      size: cover;
    }
  }

  &__meta {
    display: flex;
    padding: 0 18px;
    margin-top: 12px;

    align-items: flex-start;
    justify-content: space-between;

    ul {
      margin: 0;
      list-style: none;
      line-height: 1.5em;
    }
  }
  &__table-container {
    // max-height: calc(100vh - 245px); // stupid safari...
    overflow: auto;
  }

  &__content {
    background-color: white;
    max-height: 80vh;
    max-width: 800px;
    margin: 0 20px;
    width: 100%;
    border-radius: 6px;
    display: flex;
    flex-direction: column;

    table {
      border-spacing: 0;
      width: 100%;
    }

    table.stats__table {
      border-spacing: 0;
      border: 1px solid $border-medium;
      border-radius: 4px;
      overflow: hidden;
      width: calc(100% - 30px);
      margin: 18px 15px;

      .col-year {
        border-bottom: 1px solid $border-medium;
      }
      td {
        min-width: 70px;
        padding: 4px 6px;
        border-right: 1px solid $border-medium;
        &.has-table {
          padding: 0;
          min-width: 232px;
        }
        table tr td {
          width: 50%;
          &:last-child {
            border-right: 0;
          }
        }
      }
      & > thead > td {
        border-bottom: 1px solid $border-medium;
      }
      & > tr {
        &:nth-of-type(odd) {
          background-color: $border;
        }
      }
      thead {
        td {
          font-weight: bold;
          background-color: #72acd2;
          color: white;

          &:first-child {
            border-right: 1px solid $border-medium;
          }
        }
        td:not(.force-padding) {
          padding: 0;

          table {
            td {
              padding: 6px;
              .table-head-sortable {
                cursor: pointer;
                width: 100%;
                display: flex;
                justify-content: space-between;
                align-items: center;
                .wrap {
                  @include truncate();
                  max-width: 65%;
                }
                span.up,
                span.down {
                  display: inline-block;
                  width: 0;
                  height: 0;
                  border-top: 6px solid white;
                  border-left: 6px solid transparent;
                  border-right: 6px solid transparent;
                }
                span.up {
                  transform: rotate(180deg);
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
